export class ErrorResponse {
  constructor(msg) {
    this.error = msg;
  }
}
